import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { ShapesDecorativeBorder } from 'src/components';
import { SalesforceContext } from 'src/context/salesforce-context';
import { OnboardingFormBackground } from '../../onboarding-form-background/onboarding-form-background';
import useTechnicalErrorHandler from 'src/hooks/useTechnicalError';
import SalesforceRequestOtpForm from 'src/components/salesforce-request-otp-form/salesforce-request-otp-form';
import TealiumEvents from 'src/helpers/tealium-events';
import { onboardingContinueOtpRoute } from 'src/routing/routes';
import './enter-reference.scss';

function EnterReference() {
  const { resumeSessionRequestOTP, customerType, lead } = useContext(SalesforceContext);
  const [redirectToRoute, setRedirectToRoute] = useState('');
  const handleTechnicalError = useTechnicalErrorHandler();

  if (!!redirectToRoute) {
    return <Redirect push to={redirectToRoute} />;
  }

  const form = () => (
    <section className="enter-reference">
      <div className="columns is-gapless is-centered is-mobile">
        <div className="column is-four-fifths form-content">
          <div className="has-text-centered">
            <p className="heading-continue-your-application">Continue your application</p>
            <p className="sub-heading-expect-email">We'll send you an email with an OTP.</p>
          </div>
          <SalesforceRequestOtpForm
            onFormLoad={() => {
              const assistantId = lead.dealerId || lead.agentId || '';
              TealiumEvents.continueApplicationPageLoadFormStartCombined(customerType, assistantId);
            }}
            requestOtp={resumeSessionRequestOTP}
            onOtpSent={() => {
              TealiumEvents.continueApplicationReferenceFormEndContinueClickCombined();
              setRedirectToRoute(onboardingContinueOtpRoute);
            }}
            onReferenceNumberIncorrect={() =>
              TealiumEvents.continueApplicationReferenceEventError(
                'Reference number is incorrect',
                customerType,
              )
            }
            onApplicationAlreadySubmitted={() =>
              TealiumEvents.continueApplicationReferenceEventError(
                'Your application has already been submitted.',
                customerType,
              )
            }
            onTechnicalError={handleTechnicalError}
            automationIdPrefix="Onboarding_Continue_Your_Application"
          />
        </div>
      </div>
    </section>
  );
  return (
    <OnboardingFormBackground includeMiniAppBack={true}>
      <ShapesDecorativeBorder>{form()}</ShapesDecorativeBorder>
    </OnboardingFormBackground>
  );
}

export default EnterReference;
